import { fromPairs } from 'lodash';

const options = {
  v2app: {
    displayHeaderTitle: true,
    displayFigureCaption: false,
    displayGlobalFooter: true,
    displayBreakdownSelect: true,
    allowShare: false,
    allowDownload: false,
    allowFullscreen: true,
    allowTour: true,
    displayControls: true,
    displayFooterTabs: true,
  },

  app: {
    displayHeaderTitle: true,
    displayFigureCaption: true,
    displayGlobalFooter: true,
    displayBreakdownSelect: true,
    allowShare: true,
    allowDownload: true,
    allowFullscreen: true,
    allowTour: true,
    displayControls: true,
    displayFooterTabs: true,
  },

  figure: {
    displayHeaderTitle: false,
    displayFigureCaption: true,
    displayGlobalFooter: false,
    displayBreakdownSelect: false,
    allowShare: false,
    allowDownload: false,
    allowFullscreen: false,
    allowTour: false,
    displayControls: false,
    displayFooterTabs: false,
  },

  download: {
    displayHeaderTitle: false,
    displayFigureCaption: false,
    displayGlobalFooter: false,
    displayBreakdownSelect: false,
    allowShare: false,
    allowDownload: false,
    allowFullscreen: false,
    allowTour: false,
    displayControls: false,
    displayFooterTabs: false,
  },
};

const displayModeNames = Object.keys(options);

export const DISPLAY_MODES = fromPairs(
  displayModeNames.map((mode) => [mode, Object.freeze(options[mode])]),
);

export const DISPLAY_OPTIONS = Object.keys(DISPLAY_MODES.app);
